<template>
  <div>
    <div v-if="$route.query.simulation == 'true'" class="yetou">
      <img src="../assets/images/页头.jpg" alt="" />
    </div>
    <video-player-vue
      ref="videoPlayer"
      :class="{ player: !ShowVideo, autoPlayer: ShowVideo }"
      :mp4Url="'https://fangzhen.autotool.com.cn/StaticResources/rcyh.mp4'"
    ></video-player-vue>
    <div class="banner">
      <div class="top">
        <div class="img-item">
          <img class="img1" loading="lazy" :src="img1Src" alt />
          <!-- <img class="img2" loading="lazy" :src="img2Src" alt /> -->
        </div>
        <!-- <div class="banner-info flex a-center j-end">
          <img src="@/assets/images/catalogue/volume.png" alt>
          <span>成都融畅易和科技有限公司，最新开发实训管理系统已完成上线。</span>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import VideoPlayerVue from "../components/VideoPlayer.vue";
export default {
  data() {
    return {
      img1Src: require("@/assets/images/newTOP.jpg"),
      // img2Src: require("@/assets/images/catalogue/zhutu.png"),
      ShowVideo: true,
    };
  },
  components: { VideoPlayerVue },
  props: {},
  methods: {},
  mounted() {
    document.addEventListener("click", (e) => {
      if (e.target.className != "autoPlayer") {
        this.ShowVideo = false;
      }
    });
    setTimeout(() => {
      if (this.ShowVideo) {
        this.ShowVideo = false;
      }
    }, 10000);
  },
  watch: {},
  computed: {},
};
</script>

<style scoped lang='scss'>
.player {
  width: 29% !important;
  // height: 304px !important;
  position: absolute;
  z-index: 999999999;
  right: 19%;
  top: 20%;
}
.autoPlayer {
  width: 65% !important;
  // height: 304px !important;
  position: absolute;
  z-index: 999999999;
  right: 17.5%;
  top: 8%;
}
.banner {
  width: 100%;
  height: auto;
  position: relative;
}
.yetou {
  width: 100%;
  height: auto;
  position: relative;
}
.yetou > img {
  width: 100%;
  height: auto;
  position: relative;
}
.top {
  overflow: hidden;
  /* transition: height 2s; */
}

.img-item {
  // height: 0;
  width: 100%;
  // padding-bottom: 30.2%;
  position: relative;
  overflow: hidden;
}

.img-item > img {
  width: 100%;
  object-fit: contain;
}

.unit-image {
  z-index: 1;
  position: absolute;
  border: 0;
  margin: 0;
  padding: 0;
  left: 50%;
  right: auto;
  bottom: 0px;
  top: auto;
  transform: translatex(-50%);
}
.img2 {
  display: none;
}

@media screen and (max-width: 1366px) {
  // .img-item {
  //   height: 0;
  //   width: 100%;
  //   padding-bottom: 30%;
  //   position: relative;
  // }
  .img1 {
    display: none;
  }
  .img2 {
    display: block !important;
  }

  .banner-info {
    padding-right: 47% !important;
  }
}

.swiper-button-next,
.swiper-button-prev {
  opacity: 0;
  transition: opacity 0.3s;
}

.swiper-container:hover > .swiper-button-next,
.swiper-container:hover > .swiper-button-prev {
  opacity: 1;
}

.swiper-button-next:after,
.swiper-container-rtl .swiper-button-prev:after,
.swiper-button-prev:after,
.swiper-container-rtl .swiper-button-next:after {
  display: none !important;
}

.swiper-container-horizontal > .swiper-pagination-bullets,
.swiper-pagination-custom,
.swiper-pagination-fraction {
  bottom: 70px !important;
}

.banner-info {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 52px;
  z-index: 2;
  background: rgba(20, 0, 5, 0.75);
  box-sizing: border-box;
  padding-right: 55%;
}

.banner-infos {
  position: absolute;
  bottom: 0;
  height: 52px;
  right: 20%;
}

.banner-info img {
  font-size: 20px;
  width: 20px;
  height: 20px;
  margin-right: 5px;
}

.banner-info span {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 42px;
}
</style>